// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7795":"af4ba373","9298":"c004c261","9920":"0772be19"}[chunkId] + ".chunk.css";
};